












import { mapState } from 'vuex';
import Feature from '@arcgis/core/widgets/Feature';
import Circle from '@arcgis/core/geometry/Circle';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    computed: {
        ...mapState(['leftDrawerOpen']),
    },
})
export default class EsriPopup extends Vue {

    get popupShow(): boolean {
        return this.$store.state.leftDrawerContent.popup;
    }

    get leftDrawerOpen() {
        return this.$store.state.leftDrawerOpen;
    }

    get mapView() {
        return this.$store.state.mapView;
    }

    get searchLayer() {
        return this.$store.state.search.layer;
    }

    get user() {
        return this.$store.state.user;
    }

    get searchLayerView() {
        return this.$store.state.search.layerView;
    }

    get isMobile() {
        return this.$store.state.isMobile;
    }

    get mikmawPlaceNamesLayerURL() {
        return this.$store.state.search.layer.parsedUrl.path;
    }

    public highlightHandle: __esri.Handle | null = null;

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'initPopup') {
            this.initPopup();
        } else if (action.type === 'popupFromSearch') {
            this.popupGraphic(action.payload);
        }
    });

    @Watch('leftDrawerOpen', { immediate: false, deep: true })
    public leftDrawerChanged(value: boolean, oldValue: boolean) {
        if (this.$store.state.search.layer) {
            this.$store.state.search.layer.popupEnabled = !value;
        }
        if (this.highlightHandle) {
            this.highlightHandle.remove();
        }
    }

    public onClose() {
        this.$store.dispatch('drawerToggleLeft', 'nothing');
    }

    public initPopup() {
        this.mapView.on('click', (event: any) => {
            // IMPROVE THIS: we need to check if at the /admin url -
            // The user object is stored in local storage on the same domain so the public side will use the native popup if logged in
            if (this.isMobile || window.location.href.indexOf('admin') !== -1) {
                // Attempt a wider radius search for popups in mobile
                const pxToMeters = this.mapView.extent.width / this.mapView.width;
                const c = new Circle({
                    center: event.mapPoint,
                    radius: 8 * pxToMeters, // meters by default
                });
                const q = this.searchLayer.createQuery();
                q.geometry = c;
                this.searchLayer.queryFeatures(q).then( (results: any) => {
                    if (!this.mapView.popup.visible) {
                        if (results.features.length > 0) {
                            console.log('Open wide range popup');
                            // console.log(results.features[0]);
                            this.popupGraphic(results.features[0]);
                        }
                    }
                });
            } else {
                this.mapView.hitTest(event).then((response: any) => {
                    if (response.results[0].graphic.attributes.hasOwnProperty('clusterId')) {
                        this.mapView.goTo({
                            target: response.results[0].graphic.geometry,
                            zoom: this.mapView.zoom + 1,
                        });
                    } else if (response.results && response.results.length > 0 && response.results[0].graphic.layer.parsedUrl.path === this.mikmawPlaceNamesLayerURL) {
                        if (!this.leftDrawerOpen) {
                            this.$store.dispatch('drawerToggleLeft', 'popup');
                        }

                        this.popupGraphic(response.results[0].graphic);
                    }
                });
            }
        });
    }

    public popupGraphic(graphic: __esri.Graphic) {
        if (this.isMobile || window.location.href.indexOf('admin') !== -1) {
            this.mapView.popup.open({
                features: [graphic],
                location: graphic.geometry,
            });
        } else {
            if (!this.leftDrawerOpen) {
                this.$store.dispatch('drawerToggleLeft', 'popup');
            }
            const container = document.getElementById('esriPopup');
            if (container) {
                container.innerHTML = '';
            }
            const feature = new Feature({
                graphic,
                view: this.mapView,
                container: 'esriPopup',
            });
            if (this.highlightHandle) {
                this.highlightHandle.remove();
            }
            this.highlightHandle = this.searchLayerView.highlight(graphic);
        }
    }

    public mounted() {
        console.log('EsriPopup: mounted()');
    }

    public beforeDestroy() {
        this.unsubscribe();
    }
}

